import { defineNuxtPlugin } from '#app'
import { CronVuetifyPlugin } from '@vue-js-cron/vuetify'
import '@vue-js-cron/vuetify/dist/vuetify.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(CronVuetifyPlugin)
})
